import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert
} from '@mui/material';
import PropTypes from 'prop-types';
import { deleteCompanyUser, fetchCompanyUsers, fetchCompanyStats } from '../../redux/slices/companySlice';
import alertify from 'alertifyjs';

const DeleteUserDialog = ({ open, onClose, user }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  
  const handleDelete = async () => {
    setLoading(true);
    
    try {
      await dispatch(deleteCompanyUser(user._id)).unwrap();
      
      alertify.success('Kullanıcı silindi');
      
      // Refresh list & stats
      dispatch(fetchCompanyUsers({}));
      dispatch(fetchCompanyStats());
      
      onClose();
    } catch (error) {
      alertify.error(error.message || 'Kullanıcı silinemedi');
    } finally {
      setLoading(false);
    }
  };
  
  if (!user) return null;
  
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ color: 'error.main' }}>Kullanıcıyı Sil</DialogTitle>
      <DialogContent>
        <Alert severity="error" sx={{ mb: 2 }}>
          Bu işlem geri alınamaz!
        </Alert>
        
        <Typography variant="body2">
          <strong>{user.firstName} {user.lastName}</strong> adlı kullanıcıyı silmek istediğinizden emin misiniz?
        </Typography>
        
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>
          Kullanıcının tüm verileri silinecektir.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          İptal
        </Button>
        <Button
          onClick={handleDelete}
          variant="contained"
          color="error"
          disabled={loading}
        >
          {loading ? 'Siliniyor...' : 'Sil'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteUserDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  user: PropTypes.object
};

export default DeleteUserDialog;

